<template>
  <div v-if="obra">
    <v-row :class="{ 'flex-column-reverse': vuetify?.breakpoint.smAndDown }">
      <v-col cols="12">
        <v-row>
          <Info
            cols="6"
            label="Livro"
            :value="obra.nmLivro"
            link
            @click:value="
              $router.push({
                path:
                  `/obras/visualiza/` + obra.cdObraLivro + `/` + TipoObra.LIVRO,
                query: { back: 'true' },
              })
            "
          />
        </v-row>
        <v-row dense>
          <Info cols="12" label="Autor(es)" :value="obra.autorList" />
          <Info cols="6" label="Autor entidade" :value="obra.deAutorEntidade" />
          <Info
            cols="6"
            label="Autor(es) secundário(s)"
            :value="obra.autorSecundarioList"
          />
          <Info cols="6" label="Título" :value="obra.deTituloSubtitulo" />
          <Info cols="6" label="Paginação" :value="obra.dePaginacao" />
          <Info cols="6" label="Idioma(s)" :value="obra.idiomaList" />
          <Info
            cols="6"
            label="Localização fixa"
            :value="obra.deLocalizacaoFixa"
          />
          <Info cols="6" label="Classificação" :value="obra.deClassificacao" />
          <Info
            cols="6"
            label="Notação do autor"
            :value="obra.deNotacaoAutor"
          />
        </v-row>
      </v-col>
    </v-row>
    <v-row dense>
      <Info
        cols="12"
        highlighted
        hide-bullet-point
        header="Notas Gerais"
        :value="obra.notaList"
      />
      <Info cols="12" highlighted header="Assunto(s)" :value="obra.assuntos" />

      <v-col cols="12">
        <TabelaLocalizacao
          v-if="obra.localizacaoList"
          class="mt-1 mb-2"
          :items="obra.localizacaoList"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import Info from '@/components/DynamicInfo.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { useVuetify } from '@/composables/useVuetify';
import { TipoObra } from '@/constants';

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);
</script>
